const wowApp = require('angular').module('wowApp.common');
const serverErrorFiller = require('./servererrorfiller');

function ServerErrorFiller() {
}

ServerErrorFiller.prototype.clearForm = serverErrorFiller.clearForm;
ServerErrorFiller.prototype.fillForm = serverErrorFiller.fillForm;

wowApp.service('ServerErrorFiller', [ServerErrorFiller]);
module.exports = serverErrorFiller; // backwards compatible


/** WEBPACK FOOTER **
 ** ./wowapp/src/common/components/servererrorfiller/index.js
 **/